import React from "react";

import { RecommendRow, RecruitmentRow, RecruitRow } from "../../components/DataRow";
import ToBack from "../../components/ToBack";
import { JournalTabs /*, DateTitle*/ } from "../Components";

export default function BrowseJournal() {
  const [list, setList] = React.useState({});
  const [progress, setProgress] = React.useState(0);
  const auth = JSON.parse(localStorage.getItem("auth"));
  const dataRow = (item) => {
    let row;
    if (item.data_category === "浏览岗位") {
      row = <RecruitmentRow {...item} />;
    } else if (item.data_category === "浏览校园招聘") {
      // to-do: 废弃
      row = <RecruitRow {...item} />;
    } else if (item.data_category === "浏览推荐信息") {
      // to-do: 废弃
      row = <RecommendRow {...item} />;
    }
    return row;
  };
  const handleLogIn = async () => {
    location.href = "#/登录";
  };

  React.useEffect(() => {
    if (auth === null) return;
    const url = [
      "/api/miscellaneous/journal",
      "?option=by-ref_id-category-tag",
      `&ref_id=${auth.id}`,
      "&category=浏览岗位",
      "&tag=个人用户",
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        setList(data);
        setProgress(1);
      });
    // fetch(`/api/journal/${auth.id}`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     if (res.message) {
    //       alert(res.message);
    //     } else {
    //       const data = {};
    //       const today = moment().format('YYYY-MM-DD');
    //       res.content.forEach((item) => {
    //         let date = item.journal_date.split(' ')[0];
    //         if (today === date) {
    //           date = '今天';
    //         }
    //         if (data[date]) {
    //           data[date].push(item);
    //         } else {
    //           data[date] = [item];
    //         }
    //       });
    //       setList(data);
    //     }
    //   });
  }, []);

  React.useEffect(() => {
    if (progress === 1) {
      const lt = [];
      list.forEach((current) => {
        if (current.category.indexOf("浏览岗位") > -1) {
          lt.push(current.ref_id2);
        }
      });
      fetch(`/api/biz/job?option=by-id&list=${lt.join(",")}`)
        .then((response) => response.json())
        .then((data) => {
          const lf = [];
          list.forEach((current) => {
            if (current.category.indexOf("浏览岗位") > -1) {
              const r = data.find((element) => element.id === current.ref_id2);
              lf.push({
                journal_id: current.id,
                ref_id: current.ref_id,
                ref_id2: current.ref_id2,
                data_category: current.category,
                data_tag: current.tag,
                ref_uuid: current.ref_uuid,
                ref_uuid2: current.ref_uuid2,
                ...r,
              });
            } else lf.push(current);
          });
          setList(lf);
          setProgress(2);
        });
    }
  }, [progress]);

  return (
    <>
      {auth === null ? (
        <div className="container-fluid">
          <ToBack category="操作记录" href="#我的" />
          <div className="chat-login">
            <h6>登录后可以查看操作记录</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="card mt-2">
            <ToBack category="操作记录" href="#我的" />
            <JournalTabs category="浏览" />
            <div className="card-body">
              <div className="tab-content">
                <div className="tab-pane fade show active ">
                  {list.length > 0 &&
                    list.map((item) => (
                      <div key={item.journal_id}>
                        {dataRow(item)}
                        <hr
                          style={{
                            marginTop: "0.5rem",
                            marginBottom: "0.5rem",
                          }}
                        />
                      </div>
                    ))}
                  {/* {Object.getOwnPropertyNames(list).map((key) => (
                    <React.Fragment key={key}>
                      <DateTitle text={key} />
                      <div className="mt-2" />
                      {list[key].map((item) => (
                        <div key={item.id}>
                          {dataRow(item)}
                          <hr style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }} />
                        </div>
                      ))}
                    </React.Fragment>
                  ))} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
